import { Outlet } from "react-router";
import { persistor } from "../Store/store";
//-------------------------------------------------url
// export const base_url = "https://weddingdaydiamonds.com/webapi/api";
// export const base_url = "https://weddingdaydiamonds.com/webapi/api";
export const base_url = "https://backend.weddingdaydiamonds.com/webapi/api";

export const img_url = "https://weddingdaydiamonds.com/";

export const s3_img_url = 'https://dl2vs6wk2ewna.cloudfront.net/wdd/images/'
export const s3_img_url_home = 'https://dl2vs6wk2ewna.cloudfront.net/scrap/weddingday/home/'

// export const base_url = "https://wd.demobw.com/webapi/api";
// export const img_url = "https://wd.demobw.com/";

export const helmet_url = "https://weddingdaydiamonds.com/";
export const Klevu_test_key = 'klevu-170170704925012663'
export const private_key_klaviyo = 'pk_844c01fd1754740e5d804cbc25d0e300df'
export const private_key_klaviyo2 = 'pk_187ca9ba926e0ef704a9ab82fd7d6e9d88'

export const klaviyo_url = "https://weddingdaydiamonds.com/";
//--------------------------------------------------Api header data
export const postHeader = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

export const logout = async() => {
  await persistor.flush();
  localStorage.clear();
  sessionStorage.clear();
  window.location.reload();
  window.location.replace("/")
}


export const ErrorImg = (id) => {
    const img = "https://dl2vs6wk2ewna.cloudfront.net/images/no_image_available.webp";
    console.log("ImageError sku: ", id)
    document.getElementById(id).src = img;
}